import React, { useState, useEffect } from "react";
import PulseLoader from "react-spinners/PulseLoader";
import PropTypes from "prop-types";
import { Dropdown, Button, TextInput } from "hesus-ui-kit";
import { withTranslation } from "react-i18next";
import { updateUnitTranslation } from "@utils/utils";
import {
  GridRow,
  APIErrorMEssage,
  LoadingContainer,
  OptionLabel,
  SectionContainer,
  TransportSection,
} from "../AddEditSolution.styled";

import { country } from "@utils/constants";

const TransportTreatmentSeparated = (props) => {
  const {
    data,
    solution,
    countryId,
    currencies,
    transportTypes,
    addTransportPriceSection,
    transportTypesAPIError,
    isTransportTypesLoading,
    onTreatmentPriceChange,
    onTreatmentCurrencySelect,
    onTreatmentUnitSelect,
    onTGAPChange,
    onPollutionCommentChange,
    selectTransportPrice,
    onAddTransportPrice,
    onPriceBySelect,
    onTransportTypeSelect,
    onTransportUnitSelect,
    onTransportPriceChange,
    onTransportCurrencySelect,
    t,
    unitList,
    enquirySubCategoryId,
  } = props;

  const [solutionTransportType, setSolutionTransportType] = useState({
    value: "",
    error: "",
    required: true,
  });
  const [solutionTransportPriceType, setSolutionTransportPriceType] = useState({
    value: "",
    error: "",
    required: true,
  });

  const [solutionPrice, setSolutionPrice] = useState("");
  const [solutionCurrency, setSolutionCurrency] = useState(
    parseInt(countryId, 10)
  );
  const [solutionUnit, setSolutionUnit] = useState("");
  const [oldTransportPriceInfo, setOldTransportPriceInfo] = useState({});
  const [transportPricesList, setTransportPricesList] = useState([]);

  const onTransportTypeEdit = (e) => {
    setSolutionTransportType({
      value: e.value,
      error: "",
      required: true,
    });
    onTransportTypeSelect(e);
  };

  const onTransportPriceTypeEdit = (e) => {
    setSolutionTransportPriceType({
      value: e.value,
      error: "",
      required: true,
    });
    onPriceBySelect(e);
  };

  const onTransportSolutionPriceEdit = (e) => {
    setSolutionPrice(
      e.target.value === "" || /^[0-9]*[.,]?[0-9]*$/.test(e.target.value)
        ? e.target.value
        : solutionPrice
    );
    onTransportPriceChange(e);
  };

  const onTransportSolutionCurrencyEdit = (e) => {
    setSolutionCurrency(e);
    onTransportCurrencySelect(e);
  };

  const onTransportSolutionUnitEdit = (e) => {
    setSolutionUnit(e);
    onTransportUnitSelect(e);
  };

  useEffect(() => {
    setOldTransportPriceInfo({
      transportType: {
        value: data.transportType.value,
        error: "",
        required: true,
      },
      transportPriceType: {
        value: data.transportPriceType.value,
        error: "",
        required: true,
      },
      price: data.transportPrice,
      currency: data.transportCurrency.value,
      unit: data.transportUnit,
      selectedTransportPriceId: data.selectedTransportPriceId.value,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (data.transportPriceType?.error) {
      setOldTransportPriceInfo({
        ...oldTransportPriceInfo,
        transportPriceType: {
          value: "",
          error: data.transportPriceType.error,
          required: true,
        },
      });

      setSolutionTransportPriceType({
        ...solutionTransportPriceType,
        value: "",
        error: t(data.transportPriceType.error),
      });
    }
    if (data.transportType?.error) {
      setOldTransportPriceInfo({
        ...oldTransportPriceInfo,
        transportType: {
          value: "",
          error: data.transportType.error,
          required: true,
        },
      });
      setSolutionTransportType({
        ...solutionTransportType,
        value: "",
        error: t(data.transportType.error),
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data.transportPriceType.error, data.transportType.error]);

  useEffect(() => {
    if (solution?.solutionTransportPrices) {
      const pricesList = solution.solutionTransportPrices.map((priceItem) => {
        return {
          label: `${
            priceItem.transportPriceType?.type
              ? `${t(priceItem.transportPriceType?.type)} -`
              : ""
          } ${
            priceItem.transportType?.name
              ? `${priceItem.transportType?.name} -`
              : ""
          } ${t(priceItem.price)} ${t(priceItem.currency?.name)}/${t(
            priceItem.unit
          )}`,
          value: priceItem.id,
        };
      });
      setTransportPricesList(pricesList);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [solution?.solutionTransportPrices]);

  useEffect(() => {
    if (
      !addTransportPriceSection &&
      solution &&
      oldTransportPriceInfo?.selectedTransportPriceId
    ) {
      setSolutionPrice(oldTransportPriceInfo.price);
      setSolutionCurrency(parseInt(countryId, 10));
      setSolutionUnit(oldTransportPriceInfo.unit);
      setSolutionTransportType(oldTransportPriceInfo.transportType);
      setSolutionTransportPriceType(oldTransportPriceInfo.transportPriceType);

      selectTransportPrice({
        name: "solution-dropdown-transport-option",
        value: oldTransportPriceInfo.selectedTransportPriceId,
      });
    }
    if (addTransportPriceSection) {
      setSolutionPrice("");
      setSolutionCurrency(parseInt(countryId, 10));
      setSolutionUnit("");
      setSolutionTransportType({
        ...solutionTransportType,
        value: "",
      });
      setSolutionTransportPriceType({
        ...solutionTransportPriceType,
        value: "",
      });
      selectTransportPrice({
        name: "solution-dropdown-transport-option",
        value: "",
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [addTransportPriceSection]);
  return (
    <SectionContainer>
      <div>
        <OptionLabel>{t("TREATMENT_ONLY")}</OptionLabel>
        <GridRow>
          <TextInput
            type="text"
            label={t("TREATMENT_PRICE")}
            name="treatment-price"
            id="treatment-price"
            isFloat
            value={String(data.treatmentPrice)}
            onChange={onTreatmentPriceChange}
            containerStyles={{ marginTop: "1.32rem" }}
            inputStyles={{ padding: "0.43rem 0.32rem 0.43rem 0.625rem" }}
          />
          <Dropdown
            label={t("MATCHING_TREATMENT_PRICE_CURRENCY")}
            name="currency"
            value={String(data.treatmentCurrency.value)}
            defaultOption={t("SELECT_CURRENCY")}
            options={currencies}
            containerStyles={{ marginBottom: "1.32rem" }}
            inputStyles={{ border: "1px solid #474747" }}
            error={data.treatmentCurrency.error}
            required
            onChange={onTreatmentCurrencySelect}
          />
          <Dropdown
            label={t("UNIT")}
            name="solution-dropdown-unit"
            value={String(data.treatmentUnit)}
            defaultOption="NONE_SELECTED"
            containerStyles={{ marginBottom: "1.32rem" }}
            inputStyles={{ border: "1px solid #474747" }}
            options={updateUnitTranslation(unitList, t)}
            onChange={onTreatmentUnitSelect}
          />
        </GridRow>
        {parseInt(enquirySubCategoryId, 10) === 1 && (
          <div style={{ width: "66%" }}>
            <TextInput
              type="text"
              label={t("TGAP")}
              name="tgap"
              id="tgap"
              value={data.tgap ? String(data.tgap) : ""}
              onChange={onTGAPChange}
            />
          </div>
        )}
        {/* Show only for France */}
        {parseInt(enquirySubCategoryId, 10) === 1 && (
          <div style={{ marginTop: "1.32rem" }}>
            <TextInput
              type="textarea"
              label={t("CONCERNED_POLLUTION")}
              id="pollution_comment"
              name="pollution_comment"
              value={data.pollutionComment.value}
              required={countryId === country.France}
              error={
                countryId === country.France ? data.pollutionComment.error : ""
              }
              onChange={onPollutionCommentChange}
              inputStyles={{ height: "4rem" }}
            />
          </div>
        )}
      </div>
      <TransportSection>
        <OptionLabel>{t("TRANSPORT")}</OptionLabel>
        {solution && (
          <>
            <GridRow>
              <Dropdown
                label={t("TRANSPORT_PRICE")}
                name="solution-dropdown-transport-option"
                // condition if changing solution from tt+tp to tt & tp seperate admin should select tranport again in edit case
                value={
                  solution.priceType !== 2 &&
                  data.priceType !== 1 &&
                  data.selectedTransportPriceId?.value
                    ? parseInt(data.selectedTransportPriceId.value, 10)
                    : ""
                }
                defaultOption={t("SELECT")}
                containerStyles={{ marginBottom: "1.32rem" }}
                inputStyles={{ border: "1px solid #474747" }}
                options={transportPricesList}
                required
                disabled={addTransportPriceSection}
                error={data.selectedTransportPriceId.error}
                onChange={selectTransportPrice}
              />
              <Button
                styles={{
                  color: "white",
                  alignSelf: "center",
                  padding: "0.75rem 0.875rem",
                  background: addTransportPriceSection ? "#ED6B08" : "#1BACE4",
                  border: addTransportPriceSection
                    ? "1px solid #ED6B08"
                    : "1px solid #1BACE4",
                  marginRight: "0.32rem",
                  "&:hover": {
                    backgroundColor: addTransportPriceSection
                      ? "#bd5506"
                      : "#1589b6",
                  },
                }}
                onClick={onAddTransportPrice}
              >
                {!addTransportPriceSection && t("ADD_TRANSPORT_PRICE")}
                {addTransportPriceSection && t("CANCEL")}
              </Button>
            </GridRow>
            {addTransportPriceSection && (
              <>
                <GridRow>
                  <Dropdown
                    label={t("MANUAL_MATCHING_CREATION_POP_UP_PRICE_BY")}
                    name="solution-dropdown-price-by"
                    value={
                      solutionTransportPriceType?.value
                        ? parseInt(solutionTransportPriceType?.value, 10)
                        : ""
                    }
                    defaultOption={t("NONE_SELECTED")}
                    containerStyles={{ marginBottom: "1.32rem" }}
                    inputStyles={{
                      border: "1px solid #474747",
                    }}
                    options={[
                      {
                        label: t("ADMIN_OPTMIZED"),
                        value: 4,
                      },
                      {
                        label: t("SUPPLIER_OPTIMIZED"),
                        value: 3,
                      },
                    ]}
                    required
                    error={solutionTransportPriceType?.error}
                    onChange={onTransportPriceTypeEdit}
                  />
                  {transportTypesAPIError !== "" && (
                    <APIErrorMEssage>{transportTypesAPIError}</APIErrorMEssage>
                  )}
                  {isTransportTypesLoading && (
                    <LoadingContainer>
                      <PulseLoader color="#004c7f" />
                    </LoadingContainer>
                  )}
                  {!isTransportTypesLoading && transportTypesAPIError === "" && (
                    <Dropdown
                      label={t("TRANSPORT_TYPE")}
                      name="solution-dropdown-transport-type"
                      value={
                        solutionTransportType?.value
                          ? parseInt(solutionTransportType?.value, 10)
                          : ""
                      }
                      defaultOption={t("NONE_SELECTED")}
                      containerStyles={{
                        marginBottom: "1.32rem",
                      }}
                      inputStyles={{
                        border: "1px solid #474747",
                      }}
                      options={transportTypes}
                      required
                      error={solutionTransportType?.error}
                      onChange={onTransportTypeEdit}
                    />
                  )}
                </GridRow>
                <GridRow align="flex-start">
                  <TextInput
                    type="text"
                    label={t("TRANSPORT_PRICE")}
                    name="transport-price"
                    id="transport-price"
                    isFloat
                    value={String(solutionPrice)}
                    onChange={onTransportSolutionPriceEdit}
                    containerStyles={{ marginTop: "1.32rem" }}
                    inputStyles={{
                      padding: "0.43rem 0.32rem 0.43rem 0.625rem",
                    }}
                  />
                  <Dropdown
                    label={t("MATCHING_TREATMENT_PRICE_CURRENCY")}
                    name="currency"
                    value={String(solutionCurrency)}
                    defaultOption={t("SELECT_CURRENCY")}
                    containerStyles={{ marginBottom: "1.32rem" }}
                    inputStyles={{
                      border: "1px solid #474747",
                    }}
                    options={currencies}
                    required
                    error={data.transportCurrency.error}
                    onChange={onTransportSolutionCurrencyEdit}
                  />
                  <Dropdown
                    label={t("UNIT")}
                    name="solution-dropdown-unit"
                    value={String(solutionUnit)}
                    defaultOption={t("NONE_SELECTED")}
                    containerStyles={{ marginBottom: "1.32rem" }}
                    inputStyles={{
                      border: "1px solid #474747",
                    }}
                    options={updateUnitTranslation(unitList, t)}
                    onChange={onTransportSolutionUnitEdit}
                  />
                </GridRow>
              </>
            )}
          </>
        )}
        {!solution && (
          <>
            <GridRow>
              <Dropdown
                label={t("MANUAL_MATCHING_CREATION_POP_UP_PRICE_BY")}
                name="solution-dropdown-price-by"
                value={
                  data.transportPriceType.value
                    ? parseInt(data.transportPriceType.value, 10)
                    : ""
                }
                defaultOption={t("NONE_SELECTED")}
                containerStyles={{ marginBottom: "1.32rem" }}
                inputStyles={{ border: "1px solid #474747" }}
                options={[
                  {
                    label: t("ADMIN_OPTMIZED"),
                    value: 4,
                  },
                  {
                    label: t("SUPPLIER_OPTIMIZED"),
                    value: 3,
                  },
                ]}
                required
                error={data.transportPriceType.error}
                onChange={onPriceBySelect}
              />
              {transportTypesAPIError !== "" && (
                <APIErrorMEssage>{transportTypesAPIError}</APIErrorMEssage>
              )}
              {isTransportTypesLoading && (
                <LoadingContainer>
                  <PulseLoader color="#004c7f" />
                </LoadingContainer>
              )}
              {!isTransportTypesLoading && transportTypesAPIError === "" && (
                <Dropdown
                  label={t("TRANSPORT_TYPE")}
                  name="solution-dropdown-transport-type"
                  value={data.transportType.value}
                  defaultOption={t("NONE_SELECTED")}
                  containerStyles={{ marginBottom: "1.32rem" }}
                  inputStyles={{
                    border: "1px solid #474747",
                  }}
                  options={transportTypes}
                  required
                  error={data.transportType.error}
                  onChange={onTransportTypeSelect}
                />
              )}
            </GridRow>
            <GridRow>
              <TextInput
                type="text"
                label={t("TRANSPORT_PRICE")}
                name="transport-price"
                id="transport-price"
                value={String(data.transportPrice)}
                isFloat
                onChange={onTransportPriceChange}
                containerStyles={{ marginTop: "1.32rem" }}
                inputStyles={{ padding: "0.43rem 0.32rem 0.43rem 0.625rem" }}
              />
              <Dropdown
                label={t("MATCHING_TREATMENT_PRICE_CURRENCY")}
                name="currency"
                value={String(data.transportCurrency.value)}
                defaultOption={t("SELECT_CURRENCY")}
                containerStyles={{ marginBottom: "1.32rem" }}
                inputStyles={{ border: "1px solid #474747" }}
                options={currencies}
                required
                error={data.transportCurrency.error}
                onChange={onTransportCurrencySelect}
              />
              <Dropdown
                label={t("UNIT")}
                name="solution-dropdown-unit"
                value={String(data.transportUnit)}
                defaultOption={t("NONE_SELECTED")}
                containerStyles={{ marginBottom: "1.32rem" }}
                inputStyles={{ border: "1px solid #474747" }}
                options={updateUnitTranslation(unitList, t)}
                onChange={onTransportUnitSelect}
              />
            </GridRow>
          </>
        )}
      </TransportSection>
    </SectionContainer>
  );
};

TransportTreatmentSeparated.propTypes = {
  addTransportPriceSection: PropTypes.bool,
  countryId: PropTypes.number.isRequired,
  data: PropTypes.shape({
    treatmentPrice: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    treatmentUnit: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    treatmentCurrency: PropTypes.shape({
      value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
      error: PropTypes.string,
      required: PropTypes.bool,
    }),
    selectedTransportPriceId: PropTypes.shape({
      value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
      error: PropTypes.string,
      required: PropTypes.bool,
    }),
    tgap: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    transportPriceType: PropTypes.shape({
      value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
      error: PropTypes.string,
      required: PropTypes.bool,
    }),
    transportType: PropTypes.shape({
      value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
      error: PropTypes.string,
      required: PropTypes.bool,
    }),
    transportPrice: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    transportUnit: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    transportCurrency: PropTypes.shape({
      value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
      error: PropTypes.string,
      required: PropTypes.bool,
    }),
    pollutionComment: PropTypes.shape({
      value: PropTypes.string,
      error: PropTypes.string,
      required: PropTypes.bool,
    }),
    transportPriceInternalComment: PropTypes.string,
  }).isRequired,
  solution: PropTypes.shape({
    solutionTransportPrices: PropTypes.arrayOf(PropTypes.object),
  }),
  currencies: PropTypes.arrayOf(PropTypes.object).isRequired,
  transportTypes: PropTypes.arrayOf(PropTypes.object).isRequired,
  transportTypesAPIError: PropTypes.string.isRequired,
  isTransportTypesLoading: PropTypes.bool.isRequired,
  onTreatmentPriceChange: PropTypes.func.isRequired,
  onTreatmentCurrencySelect: PropTypes.func.isRequired,
  onTreatmentUnitSelect: PropTypes.func.isRequired,
  onTGAPChange: PropTypes.func.isRequired,
  onPollutionCommentChange: PropTypes.func.isRequired,
  selectTransportPrice: PropTypes.func.isRequired,
  onAddTransportPrice: PropTypes.func.isRequired,
  onPriceBySelect: PropTypes.func.isRequired,
  onTransportTypeSelect: PropTypes.func.isRequired,
  onTransportUnitSelect: PropTypes.func.isRequired,
  onTransportPriceChange: PropTypes.func.isRequired,
  onTransportCurrencySelect: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired,
  enquirySubCategoryId: PropTypes.string,
};

TransportTreatmentSeparated.defaultProps = {
  solution: null,
  addTransportPriceSection: false,
  enquirySubCategoryId: null,
};

export default withTranslation()(TransportTreatmentSeparated);
